import { Dialog, Transition } from "@headlessui/react";
import React, { Dispatch, Fragment, SetStateAction } from "react";

// Payment modal only
export default function PercentageLetterModal({
  isOpen,
  setIsOpen,
  powerPlantName,
  onClick,
  data,
  setData,
  action,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  powerPlantName: string;
  data: any;
  setData: any;
  onClick: any;
  action: string;
}) {
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-70"
            leave="ease-in duration-200"
            leaveFrom="opacity-70"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/75" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-xl overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="rounded-2xl bg-primary500 p-10 leading-6 text-white"
                  >
                    <p className="text-4xl font-bold">
                      {action == "show" ? "Editar" : "Enviar"} rateio
                    </p>
                    <p className="text-lg font-normal text-primary100">para: {powerPlantName}</p>
                  </Dialog.Title>
                  <div className="p-10">
                    <p className="mb-4 text-center text-lg font-bold text-black">
                      Preencha com a data de início da vigência desta carta
                    </p>

                    <div className="flex w-full justify-center gap-4">
                      <input
                        className="h-6 w-11/12 rounded-3xl border p-4"
                        type="date"
                        value={data.start_date}
                        onChange={(e) => setData("start_date", e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="flex justify-end gap-2 border-t p-4">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium text-black focus:outline-none"
                      onClick={closeModal}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-3xl border border-transparent bg-black px-4 py-2 text-sm font-medium text-white focus:outline-none"
                      onClick={onClick}
                    >
                      {action == "show" ? "Editar" : "Enviar"} carta
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
